import { render, staticRenderFns } from "./broadcast-selector.vue?vue&type=template&id=d4b01f04"
import script from "./broadcast-selector.vue?vue&type=script&lang=js"
export * from "./broadcast-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports